import { getAsyncLocalStorage } from '@confluence/async-local-storage/entry-points/getAsyncLocalStorage.ts';
import { QUERY_BOUNDARY_STORAGE_NAME } from '@confluence/async-local-storage/entry-points/storageNames.ts';

export function runInQueryBoundary(name: string, callback: () => void): void {
	// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
	if (!process.env.REACT_SSR) {
		return callback();
	}

	const storage = getAsyncLocalStorage<string>(QUERY_BOUNDARY_STORAGE_NAME);
	if (!storage) {
		return callback();
	}
	return storage.run(name, callback);
}

export function getQueryBoundary(): string | null {
	// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
	if (!process.env.REACT_SSR) {
		return null;
	}

	const storage = getAsyncLocalStorage<string>(QUERY_BOUNDARY_STORAGE_NAME);
	if (!storage) {
		return null;
	}
	return storage.getStore() ?? null;
}
